export default "__VITE_ASSET__614883ed__"